import { render, staticRenderFns } from "./LiveUrl.vue?vue&type=template&id=b3cb2540&scoped=true&"
import script from "./LiveUrl.vue?vue&type=script&lang=js&"
export * from "./LiveUrl.vue?vue&type=script&lang=js&"
import style0 from "./LiveUrl.vue?vue&type=style&index=0&id=b3cb2540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3cb2540",
  null
  
)

export default component.exports